import { PanelsContainer } from '__editor/panelsEditor/models/panelsContainer';
import * as PIXI from 'pixi.js';
let panelsContainer: PanelsContainer;
let baysContainer: PanelsContainer;

export const createPanelsContainer = () => {
  panelsContainer = new PIXI.Container();
  panelsContainer.id = 'panelsContainer';
  panelsContainer.zIndex = 4;
  
  return panelsContainer;
};

export const getPanelsContainer = () => panelsContainer;

export const removePanelsContainer = () => panelsContainer = undefined;

export const createBaysContainer = () => {
  baysContainer = new PIXI.Container();
  baysContainer.id = 'baysContainer';
  baysContainer.zIndex = 5;
  
  // PIXI v7: Enable interaction for container
  baysContainer.interactive = false; // Container itself shouldn't be interactive
  baysContainer.interactiveChildren = true; // But its children should be
  baysContainer.eventMode = 'passive'; // Let events pass through to children
  
  return baysContainer;
};

export const getBaysContainer = () => baysContainer;

export const removeBaysContainer = () => baysContainer = undefined;
